import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useState } from "react";

type CopyUrlFieldProps = {
  copyText: string;
  url: string;
};

const CopyUrlField = ({ copyText, url }: CopyUrlFieldProps) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (quoteUrl: string) => {
    try {
      await navigator.clipboard.writeText(quoteUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy URL:", err);
    }
  };

  return (
    <Box>
      <>
        <Typography
          variant="bodyMedium"
          sx={{ mb: 2, color: "text.secondary" }}
        >
          {copyText}
        </Typography>
        <Stack direction="row" spacing={1} alignItems="flex-start">
          <Box sx={{ flexGrow: 1 }}>
            <TextField
              value={url}
              fullWidth
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <Box pl={1.5}>
                    <IconButton
                      onClick={() => handleCopy(url)}
                      title={copied ? "Copied!" : "Copy URL"}
                    >
                      <ContentCopyIcon />
                    </IconButton>
                  </Box>
                ),
              }}
              variant="outlined"
            />
          </Box>
        </Stack>
      </>
    </Box>
  );
};

export default CopyUrlField;
